import React from 'react';
import { Col, Dropdown, Row } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import DataTableExtensions from 'react-data-table-component-extensions';
import AnchorLink from 'react-anchor-link-smooth-scroll'
import { AiOutlineFilePdf } from 'react-icons/ai'
import { RiFileExcel2Line, RiMapPin2Line } from 'react-icons/ri'

import './index.css'
import moment from 'moment'

const customStyles = {
  rows: {
    style: {
      '&:hover': {
        backgroundColor: '#03989E',
        color: 'white',
        transition: '.2s'
      },
    }
  },
};

function MarksList({ data, markersCallback, deviceName, reportCallback, localizatorAccess }) {

  const columns = [
    {
      name: 'Temperatura',
      selector: row => `${row.temperature} °C`,
      sortable: true,
      left: true,
      width: '20%'
    },
    {
      name: 'Umidade',
      selector: row => `${row.humidity} %`,
      sortable: true,
      width: '20%'
    },
    {
      name: 'Data/Hora',
      selector: row => row.createdAt,
      format: row => moment.utc(row.createdAt).local().format('DD/MM HH:mm:ss'),
      sortable: true,
      left: true,
      width: '35%',
    },
    {
      name: '',
      cell: row => (
        <Row>
          { !localizatorAccess &&
            <Col>
              <AnchorLink href="#route-map" style={{ textDecoration: 'none' }}>
                <button className="map-address-button" style={{ width: '110px' }} onClick={() => {
                  markersCallback(row, deviceName)
                }}>
                  Localização
						  <RiMapPin2Line />
                </button>
              </AnchorLink>
            </Col>
          }
        </Row>
      ),
      sortable: true,
      right: true,
      width: '10%'
    },
  ];

  const seachData = {
    data,
    columns
  }

  function renderDropdownButton() {
    return (
      <Dropdown className="dropdown-reports" >
        <Dropdown.Toggle variant="default" id="dropdown-basic">
          Gerar Relatórios
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item 
          onClick={() => {
            reportCallback(data[0].travelId, data[0].mac, 'pdf')
          }}
          style={{color: 'red'}}
          >
            PDF
            <AiOutlineFilePdf />
          </Dropdown.Item>
          <Dropdown.Item 
          onClick={() => {
            reportCallback(data[0].travelId, data[0].mac, 'excel')
          }}
          style={{color: 'green'}}>
            Excel
            <RiFileExcel2Line />
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    )
  }

  return (
    <div className="container-fluid">
      {data.length > 0 && renderDropdownButton()}
      <DataTableExtensions
        {...seachData}
        filterPlaceholder="Pesquisar Ponto"
        print={false}
        exportHeaders={false}
        export={false}>
        <DataTable
          columns={columns}
          data={data}
          noDataComponent={
            <span>Nenhum registro de marcação encontrado</span>
          }
          pagination={true}
          customStyles={customStyles}
        />
      </DataTableExtensions>
    </div>
  );
}

export default MarksList;